export default "__VITE_ASSET__DPRKToBh__"